// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__uqPTp","choiceBoxes":"toolbarselects_choiceBoxes__31SrZ","simpleField":"toolbarselects_simpleField__2Gzub"};